class ProductRecommendations extends HTMLElement {
  constructor() {
    super();
    this.parent = this.closest('.product-recommendations--parent');
    this.init();
  }

  init() {
    this.buttonLeft = this.querySelector('.cart-drawer__button-left');
    this.buttonRight = this.querySelector('.cart-drawer__button-right');
    this.recommendationsWrapper = this.querySelector('.cart-drawer--recommendations--products');

    if (this.buttonLeft && this.buttonRight && this.recommendationsWrapper) {
      this.buttonLeft.addEventListener('click', () => this.scrollLeft());
      this.buttonRight.addEventListener('click', () => this.scrollRight());
      this.recommendationsWrapper.addEventListener('scroll', () => this.updateButtonVisibility());

      this.updateButtonVisibility(); // Check visibility on load
    }

    this.observeMutations();
  }

  scrollLeft() {
    if (this.recommendationsWrapper) {
      this.recommendationsWrapper.scrollBy({ left: -300, behavior: 'smooth' });
    }
  }

  scrollRight() {
    if (this.recommendationsWrapper) {
      this.recommendationsWrapper.scrollBy({ left: 300, behavior: 'smooth' });
    }
  }

  updateButtonVisibility() {
    if (!this.recommendationsWrapper) return;

    const { scrollLeft, scrollWidth, clientWidth } = this.recommendationsWrapper;

    // Hide left button if scrolled all the way left
    this.buttonLeft.style.display = scrollLeft <= 0 ? 'none' : 'block';

    // Hide right button if scrolled all the way right
    this.buttonRight.style.display = scrollLeft + clientWidth >= scrollWidth ? 'none' : 'block';
  }

  observeMutations() {
    const observer = new MutationObserver(() => {
      this.init(); // Reinitialize when elements change
    });

    observer.observe(this, { childList: true, subtree: true });
  }

  fetchProducts() {
    fetch(this.dataset.url)
      .then((response) => response.text())
      .then((text) => {
        const html = document.createElement('div');
        html.innerHTML = text;
        const recommendations = html.querySelector('product-recommendations');

        if (recommendations && recommendations.innerHTML.trim().length) {
          this.innerHTML = recommendations.innerHTML;

          if (this.parent) {
            this.parent.classList.add('product-recommendations--full');

            if (document.body.classList.contains('open-cart')) {
              this.parent.classList.add('active');
            }
          }
        }

        this.classList.add('product-recommendations--loaded');
        this.updateButtonVisibility(); // Update button visibility after fetching products
      })
      .catch((e) => {
        console.error(e);
      });
  }

  connectedCallback() {
    this.fetchProducts();
  }
}

customElements.define('product-recommendations', ProductRecommendations);
